import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';

import RenderRadioButton from '../../containers/CheckoutPage/RenderRadioButton';
import {connect} from 'react-redux';
import {ServiceTypeOption, Form, Label, LabelNote} from './ServiceTypeRadioButtons.style';
import {SERVICE_TYPE} from '../../constants/constant';
import {boolToServiceType} from '../../helpers/formHelper';
import {FormattedMessage} from 'react-intl';
import {getCurrentEta} from '../../helpers/date.helper';

class ServiceTypeRadioButtons extends PureComponent {
  constructor(props) {
    super(props);
  }

  getServiceTypeLabelNote(serviceType) {
    const {openForDelivery, openForCollection, restaurantModes, openingTimes} = this.props;

    if (serviceType === 'collection' && restaurantModes.collection && restaurantModes.delivery && !restaurantModes.futureOrders &&
      openForDelivery && !openForCollection) {
      return (
        <LabelNote>
          <FormattedMessage id="basket.collectionNotAvailable" />
        </LabelNote>
      );
    } else if (serviceType === 'collection' && restaurantModes.collection && restaurantModes.delivery && restaurantModes.futureOrders &&
      !openForCollection) {
      return (
        <LabelNote>
          <FormattedMessage id="basket.collectionPreorderOnly" />
        </LabelNote>
      );
    } else if (serviceType === 'collection') {
      const eta = getCurrentEta(openingTimes.collection);
      return (
        <LabelNote eta>
          <FormattedMessage
            id="basket.eta"
            values={{eta: `${eta.minEta} - ${eta.maxEta}`}}
          />
        </LabelNote>
      );
    } else if (serviceType === 'delivery' && restaurantModes.collection && restaurantModes.delivery && !restaurantModes.futureOrders &&
      !openForDelivery && openForCollection) {
      return (
        <LabelNote>
          <FormattedMessage id="basket.deliveryNotAvailable" />
        </LabelNote>
      );
    } else if (serviceType === 'delivery' && restaurantModes.collection && restaurantModes.delivery && restaurantModes.futureOrders &&
      !openForDelivery) {
      return (
        <LabelNote>
          <FormattedMessage id="basket.deliveryPreorderOnly" />
        </LabelNote>
      );
    } else {
      const eta = getCurrentEta(openingTimes.delivery);
      return (
        <LabelNote eta>
          <FormattedMessage
            id="basket.eta"
            values={{eta: `${eta.minEta} - ${eta.maxEta}`}}
          />
        </LabelNote>
      );
    }
  }

  render() {
    const {setServiceType, openForDelivery, openForCollection, isValidating, restaurantModes} = this.props;
    const renderLabelNoteForCollection = this.getServiceTypeLabelNote('collection');
    const renderLabelNoteForDelivery = this.getServiceTypeLabelNote('delivery');

    return (
      <Form>
        <ServiceTypeOption>
          <Field
            id="sidebasketCollection"
            name="serviceType"
            type="radio"
            value={SERVICE_TYPE.COLLECTION}
            component={RenderRadioButton}
            callback={setServiceType}
            isDisabled={!openForCollection && !restaurantModes.futureOrders || isValidating}
          />
          <Label
            htmlFor="sidebasketCollection"
            isDisabled={!openForCollection && !restaurantModes.futureOrders}
          >
            <FormattedMessage id="basket.collection" />
          </Label>
          {renderLabelNoteForCollection}
        </ServiceTypeOption>
        <ServiceTypeOption>
          <Field
            id="sidebasketDelivery"
            name="serviceType"
            type="radio"
            value={SERVICE_TYPE.DELIVERY}
            component={RenderRadioButton}
            callback={setServiceType}
            isDisabled={!openForDelivery && !restaurantModes.futureOrders || isValidating}
          />
          <Label
            htmlFor="sidebasketDelivery"
            isDisabled={!openForDelivery && !restaurantModes.futureOrders}
          >
            <FormattedMessage id="basket.delivery" />
          </Label>
          {renderLabelNoteForDelivery}
        </ServiceTypeOption>
      </Form>
    );
  }
}

ServiceTypeRadioButtons.propTypes = {
  setServiceType: PropTypes.func.isRequired,
  openForDelivery: PropTypes.bool.isRequired,
  openForCollection: PropTypes.bool.isRequired,
  isValidating: PropTypes.bool.isRequired,
  acceptFutureOrders: PropTypes.bool.isRequired,
  restaurantModes: PropTypes.object.isRequired,
  openingTimes: PropTypes.object.isRequired
};

const form = {
  form: 'serviceTypeRadioButtons',
  destroyOnUnmount: false
};

function mapStateToProps(state, props) {
  const {fulfillment} = state.basket;

  let serviceTypeInitialValue;
  if (props.openForDelivery && props.openForCollection || props.acceptFutureOrders) {
    serviceTypeInitialValue = fulfillment && fulfillment.delivery ? boolToServiceType(fulfillment.delivery) : SERVICE_TYPE.COLLECTION;
  } else if (props.openForDelivery && !props.openForCollection && !props.acceptFutureOrders) {
    serviceTypeInitialValue = SERVICE_TYPE.DELIVERY;
  } else if (!props.openForDelivery && props.openForCollection && !props.acceptFutureOrders) {
    serviceTypeInitialValue = SERVICE_TYPE.COLLECTION;
  } else {
    serviceTypeInitialValue = null;
  }

  return {
    initialValues: {
      serviceType: serviceTypeInitialValue
    }
  };
}

export default connect(mapStateToProps)(
  reduxForm(form)(
    ServiceTypeRadioButtons
  )
);



// WEBPACK FOOTER //
// ./components/ServiceTypeRadioButtons/ServiceTypeRadioButtons.js